import React, { useState } from "react";
import { Card, Form, Button, Table, Badge, Alert } from "react-bootstrap";
import API from "../services/api";

const GuardAttendanceHistory = () => {
  const [filters, setFilters] = useState({ from: "", to: "" });
  const [records, setRecords] = useState([]);
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);

  const fetchHistory = async () => {
    setLoading(true);
    setMessage("");
    try {
      const res = await API.get("/guard/attendance/history", { params: filters });
      setRecords(Array.isArray(res.data) ? res.data : []);
      if (!res.data?.length) setMessage("No attendance records found.");
    } catch (err) {
      setMessage(err.response?.data?.message || "Failed to fetch history.");
    } finally {
      setLoading(false);
    }
  };

  const renderStatus = (status) => {
    if (!status) return <Badge bg="secondary">N/A</Badge>;
    if (status === "completed") return <Badge bg="success">Completed</Badge>;
    if (status === "in") return <Badge bg="warning text-dark">In</Badge>;
    return <Badge bg="secondary">{status}</Badge>;
  };

  return (
    <div>
      <Card className="shadow-sm mb-3">
        <Card.Body>
          <Card.Title>Attendance History</Card.Title>
          <div className="row g-2 align-items-end">
            <div className="col-md-3">
              <Form.Label>From</Form.Label>
              <Form.Control
                type="date"
                value={filters.from}
                onChange={(e) => setFilters({ ...filters, from: e.target.value })}
              />
            </div>
            <div className="col-md-3">
              <Form.Label>To</Form.Label>
              <Form.Control
                type="date"
                value={filters.to}
                onChange={(e) => setFilters({ ...filters, to: e.target.value })}
              />
            </div>
            <div className="col-md-3">
              <Button variant="success" onClick={fetchHistory} disabled={loading} className="w-100">
                {loading ? "Loading..." : "Search"}
              </Button>
            </div>
          </div>
        </Card.Body>
      </Card>

      {message && <Alert variant="info">{message}</Alert>}

      <Card className="shadow-sm">
        <Card.Body>
          <Table striped bordered hover responsive>
            <thead>
              <tr>
                <th>Date</th>
                <th>Punch In</th>
                <th>Punch Out</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              {records.map((rec) => (
                <tr key={rec._id}>
                  <td>{rec.date ? new Date(rec.date).toLocaleDateString() : "-"}</td>
                  <td>{rec.punchIn?.time ? new Date(rec.punchIn.time).toLocaleString() : "--"}</td>
                  <td>{rec.punchOut?.time ? new Date(rec.punchOut.time).toLocaleString() : "--"}</td>
                  <td>{renderStatus(rec.status)}</td>
                </tr>
              ))}
            </tbody>
          </Table>
        </Card.Body>
      </Card>
    </div>
  );
};

export default GuardAttendanceHistory;
